/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Error_Removeprospects2Inputs */

const en_coinvestments_error_removeprospects2 = /** @type {(inputs: Coinvestments_Error_Removeprospects2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to remove prospects`)
};

/**
* | output |
* | --- |
* | "Failed to remove prospects" |
*
* @param {Coinvestments_Error_Removeprospects2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_error_removeprospects2 = /** @type {((inputs?: Coinvestments_Error_Removeprospects2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Error_Removeprospects2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_error_removeprospects2(inputs)
});
export { coinvestments_error_removeprospects2 as "coInvestments_error_removeProspects" }